import React from 'react'

const Template = ({ viewBox, children }) => (
  <svg viewBox={viewBox}>
    <g>
      <path
        style={{ fill: '#E9E9E0' }}
        d={
          'M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z'
        }
      />
      {children}
      <polygon
        style={{ fill: '#D9D7CA' }}
        points={'37.5,0.151 37.5,12 49.349,12'}
      />
    </g>
  </svg>
)

export default Template



// WEBPACK FOOTER //
// ./src/components/Svg/template.js